let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kaFPr")).then(() => parcelRequire('2C4l7'));